import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Heart, Shield, Zap } from 'lucide-react';
export function SolutionSection() {
  const benefits = ['Nunca más te quedes sin ideas', 'No improvises por falta de tiempo', 'Dejá de vivir buscando recursos todas las semanas', 'No tengas que adaptar cosas que no encajan', 'Recuperá la calma y el disfrute'];
  return <section className="py-12 md:py-20 bg-white overflow-hidden" data-id="element-101">
      <div className="container mx-auto px-4 md:px-6" data-id="element-102">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16" data-id="element-103">
          <div className="lg:w-1/2 w-full" data-id="element-104">
            <motion.div initial={{
            opacity: 0,
            x: -50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="relative" data-id="element-105">
              <div className="hidden md:block absolute -top-10 -left-10 w-40 h-40 bg-yellow-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob" data-id="element-106"></div>
              <div className="hidden md:block absolute -bottom-10 -right-10 w-40 h-40 bg-pink-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000" data-id="element-107"></div>

              <div className="relative bg-gradient-to-br from-sky-50 to-white p-6 md:p-8 rounded-2xl md:rounded-3xl border border-sky-100 shadow-xl" data-id="element-108">
                <div className="text-center mb-6 md:mb-8" data-id="element-109">
                  <span className="bg-sky-100 text-sky-700 px-3 py-1 rounded-full text-xs md:text-sm font-bold tracking-wide uppercase" data-id="element-110">
                    La Solución
                  </span>
                  <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mt-4" data-id="element-111">
                    Mega Pack de Recursos
                  </h3>
                  <p className="text-sm md:text-base text-slate-500 mt-2" data-id="element-112">
                    Sistema completo para Nivel Inicial
                  </p>
                </div>

                <ul className="space-y-3 md:space-y-4" data-id="element-113">
                  {benefits.map((benefit, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-114">
                      <CheckCircle className="w-5 h-5 md:w-6 md:h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-115" />
                      <span className="text-slate-700 font-medium text-sm md:text-base" data-id="element-116">
                        {benefit}
                      </span>
                    </li>)}
                </ul>
              </div>
            </motion.div>
          </div>

          <div className="lg:w-1/2 w-full" data-id="element-117">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-118">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-900 mb-4 md:mb-6 leading-tight" data-id="element-119">
                Imaginá que abrís la compu y...{' '}
                <span className="text-sky-600" data-id="element-120">ya tenés todo listo.</span>
              </h2>
              <p className="text-base md:text-lg text-slate-600 mb-4 md:mb-6 leading-relaxed" data-id="element-121">
                Actividades, recursos, propuestas e ideas pensadas
                específicamente para Nivel Inicial. Organizadas para que elijas
                rápido, sin pensar desde cero.
              </p>
              <p className="text-base md:text-lg text-slate-600 mb-6 md:mb-8 leading-relaxed" data-id="element-122">
                Llegás a la sala segura. Tranquila. Con opciones. Y volvés a tu
                casa con energía, porque la docencia deja de comerse tu vida
                personal.
              </p>

              <div className="grid grid-cols-2 gap-3 md:gap-4" data-id="element-123">
                <div className="bg-orange-50 p-3 md:p-4 rounded-xl border border-orange-100" data-id="element-124">
                  <Zap className="w-5 h-5 md:w-6 md:h-6 text-orange-500 mb-1 md:mb-2" data-id="element-125" />
                  <h4 className="font-bold text-slate-800 text-sm md:text-base" data-id="element-126">
                    Planificá rápido
                  </h4>
                  <p className="text-xs md:text-sm text-slate-600" data-id="element-127">
                    Ahorrá horas de búsqueda
                  </p>
                </div>
                <div className="bg-purple-50 p-3 md:p-4 rounded-xl border border-purple-100" data-id="element-128">
                  <Shield className="w-5 h-5 md:w-6 md:h-6 text-purple-500 mb-1 md:mb-2" data-id="element-129" />
                  <h4 className="font-bold text-slate-800 text-sm md:text-base" data-id="element-130">
                    Seguridad
                  </h4>
                  <p className="text-xs md:text-sm text-slate-600" data-id="element-131">
                    Entrá a la sala confiada
                  </p>
                </div>
                <div className="bg-pink-50 p-3 md:p-4 rounded-xl border border-pink-100" data-id="element-132">
                  <Heart className="w-5 h-5 md:w-6 md:h-6 text-pink-500 mb-1 md:mb-2" data-id="element-133" />
                  <h4 className="font-bold text-slate-800 text-sm md:text-base" data-id="element-134">
                    Disfrute
                  </h4>
                  <p className="text-xs md:text-sm text-slate-600" data-id="element-135">
                    Reconectá con tu vocación
                  </p>
                </div>
                <div className="bg-green-50 p-3 md:p-4 rounded-xl border border-green-100" data-id="element-136">
                  <CheckCircle className="w-5 h-5 md:w-6 md:h-6 text-green-500 mb-1 md:mb-2" data-id="element-137" />
                  <h4 className="font-bold text-slate-800 text-sm md:text-base" data-id="element-138">
                    Organización
                  </h4>
                  <p className="text-xs md:text-sm text-slate-600" data-id="element-139">
                    Todo en un solo lugar
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}